import React from 'react';
import { Box, Grid, Button, TextField, InputLabel } from '@mui/material';
import axios from 'axios';
import { ONBOARDAPIURL } from '../../../config'
import { APIURL } from '../../../config'
// import {render} from 'react-dom';
import MuiAlert from '@mui/material/Alert';
import Snackbar from '@mui/material/Snackbar';
import { DataGridPro } from '@mui/x-data-grid-pro';
import moment from "moment";

class onboarding extends React.Component {

    state = {
        loading: false,
        rows: [],
        success: false,
        error: false,
        warning: false,
        message: '',
        onboarding_form: {
            first_name: '',
            last_name: '',
            employee_email: '',
        }
    }

    async componentDidMount() {
        let empInvites = await axios.get(APIURL + '/activity_log', {
            params: { empID: this.props.user.emp_id },
        });

        let rows = empInvites.data.map((data) => {
            let inviteData = {
                fw_log_id: data.fw_log_id,
                action_subtype: data.action_subtype,
                systime: data.systime,
            };
            return inviteData;
        });

        this.setState({ rows: rows });
    }



    clearForm = () => {
        this.setState({
            loading: false, onboarding_form: {
                ...this.state.onboarding_form,
                first_name: '',
                last_name: '',
                employee_email: '',
            }
        })
    }

    handleOnboardingChange = (e) => {
        // if(e.target.value !== ''){
        let newState = { ...this.state.onboarding_form, [e.target.id]: e.target.value }
        this.setState({
            onboarding_form: newState
        })
        // }else{return}

    }
    handlevalidationonClick = async (e) => {
        e.preventDefault()
        console.log(this.state.onboarding_form)
        if (this.state.onboarding_form.first_name === '' || this.state.onboarding_form.last_name === ''
            || this.state.onboarding_form.employee_email === '') {
            this.setState({ warning: true, message: 'Missing Fields' })
            return
        }
        else {
            await this.addonboardingformtoDB()
        }
    }


    addonboardingformtoDB = async () => {
        // make call to onboard API

        // { "primaryBusinessType": "Support Coordination", "featureValue": 101 },
        // { "primaryBusinessType": "Case Management", "featureValue": 104 },
        let pBusinessType = this.props.user?.comp_settings.find(setting => setting.feature_value === 'primaryBusinessType') ? this.props.user.comp_settings.filter((setting) => setting.feature_value === "primaryBusinessType")[0].feature_id : 100

        console.log(pBusinessType)
        this.setState({ loading: !this.state.loading })
        let data = {
            comp_id: this.props.user.comp_id,
            company_name: this.props.user.company_name,
            user_name: this.props.user.emp_name,
            first_name: this.state.onboarding_form.first_name,
            last_name: this.state.onboarding_form.last_name,
            employee_email: this.state.onboarding_form.employee_email,
            employee_type: pBusinessType === 101 ? 'Support Coordinator' : pBusinessType === 104 ? 'Case Manager' : 'Fieldworker',
            emp_id: this.props.user.emp_id,
        }
        console.log(axios)
        console.log(data)
        let empConfirm = await axios.post(ONBOARDAPIURL + '/onboard/initaddEmployee', { ...data })
        console.log(empConfirm)
        // let empConfirm = await axios.post('http://localhost:4000/api/fieldworker/onboard/initaddEmployee', {...data})
        if (empConfirm.data.code === 200) {
            // success snackbar
            this.clearForm()
            this.setState({ success: true, message: empConfirm.data.message })

            //activty log
            const sha1 = require('sha1');
            const sessionID = window.localStorage.getItem('Fw4_access_Token');
            const hash = sha1(sessionID);
            const log_data = {
                email: this.props.user.email,
                actionType: 'Invite Employee',
                actionSubType: data.employee_email,
                sessionID: hash
            }
            await axios.post(APIURL + "/activity_log", log_data);


        } else {
            // error snackbar
            this.setState({ loading: false, error: true, message: empConfirm.data.message })
        }
        console.log('Invite User Logic', data)
    }


    render() {
        const columns = [
            { field: "fw_log_id", headerName: "FW LOG ID", hide: true },
            { field: "action_subtype", headerName: "Invite Email", width: 300 },
            {
                field: "systime",
                headerName: "Invite Date",
                width: 200,
                renderCell: (params) => {
                    return (
                        <div>{moment(params.value).isValid() ? moment(params.value).utc().format('MM/DD/YYYY, hh:mm A') : params.value}</div>
                    )
                }
            },
        ]

        return (
            <div className="team-onboarding-container" style={{ }}>
                <div style={{ borderRadius: 10, backgroundColor: '#E8E8E8', padding: '20px' }}>
                    <Box component="form" sx={{ maxWidth: '900px', margin: '0 auto' }}>
                        <h2 className='text-center' style={{ marginBottom: '20px' }}>Employee Onboarding</h2>
                        <Grid container spacing={3}>
                            <Grid size={6}>
                                <InputLabel sx={{ color: 'gray', mb: 1 }}>FIRST NAME <span style={{ color: 'red' }}>*</span></InputLabel>
                                <TextField 
                                    id="first_name"
                                    value={this.state.onboarding_form.first_name} 
                                    type="text" 
                                    onChange={this.handleOnboardingChange} 
                                    fullWidth
                                    variant="outlined"
                                    sx={{ 
                                        margin: 0,
                                        bgcolor: 'white',
                                        '& .MuiOutlinedInput-root': {
                                            '& fieldset': {
                                                borderColor: '#ccc'
                                            }
                                        }
                                    }}
                                />
                            </Grid>
                            <Grid size={6}>
                                <InputLabel sx={{ color: 'gray', mb: 1 }}>LAST NAME <span style={{ color: 'red' }}>*</span></InputLabel>
                                <TextField 
                                    id="last_name"
                                    value={this.state.onboarding_form.last_name} 
                                    type="text" 
                                    onChange={this.handleOnboardingChange} 
                                    fullWidth
                                    variant="outlined"
                                    sx={{ 
                                        bgcolor: 'white',
                                        '& .MuiOutlinedInput-root': {
                                            '& fieldset': {
                                                borderColor: '#ccc'
                                            }
                                        }
                                    }}
                                />
                            </Grid>
                        </Grid>

                        <Box sx={{ marginTop: 3 }}>
                            <InputLabel sx={{ color: 'gray', mb: 1 }}>EMAIL ADDRESS <span style={{ color: 'red' }}>*</span></InputLabel>
                            <TextField 
                                id="employee_email"
                                value={this.state.onboarding_form.employee_email} 
                                onChange={this.handleOnboardingChange} 
                                fullWidth
                                variant="outlined"
                                sx={{ 
                                    bgcolor: 'white',
                                    '& .MuiOutlinedInput-root': {
                                        '& fieldset': {
                                            borderColor: '#ccc'
                                        }
                                    }
                                }}
                            />
                        </Box>

                        <Box sx={{ display: 'flex', justifyContent: 'center', mt: 3 }}>
                            <Button 
                                disabled={!!this.state.loading ? true : false} 
                                sx={{ 
                                    width: '300px', 
                                    height: '3rem',
                                    fontSize: '1rem',
                                    textTransform: 'none'
                                }} 
                                variant="contained" 
                                type="button"
                                onClick={(e) => this.handlevalidationonClick(e)}
                            >
                                {!this.state.loading ? 'Invite User' : <div class="spinner-border" role="status">
                                    <span class="sr-only">Loading...</span>
                                </div>}
                            </Button>
                        </Box>
                    </Box>
                    <Snackbar open={this.state.success} autoHideDuration={6000} onClose={() => this.setState({ success: false })}>
                        <MuiAlert onClose={() => this.setState({ success: false })} severity="success">
                            {this.state.message}
                        </MuiAlert>
                    </Snackbar>
                    <Snackbar open={this.state.error} autoHideDuration={6000} onClose={() => this.setState({ error: false })}>
                        <MuiAlert onClose={() => this.setState({ error: false })} severity="error">
                            {this.state.message}
                        </MuiAlert>
                    </Snackbar>
                    <Snackbar open={this.state.warning} autoHideDuration={6000} onClose={() => this.setState({ warning: false })}>
                        <MuiAlert onClose={() => this.setState({ warning: false })} severity="warning">
                            {this.state.message}
                        </MuiAlert>
                    </Snackbar>
                </div>
                <div style={{ marginTop: 30, marginBottom: 10 }}>
                    <h5>Invites Sent</h5>
                </div>
                <div style={{ width: '100%', display: 'flex', justifyContent: 'flex-start' }}>
                    <Box sx={{ width: '100%', height: "calc(100vh - 525px)" }}>
                        <DataGridPro
                            getRowId={(row) => row.fw_log_id}
                            rows={this.state.rows}
                            columns={columns}
                            initialState={{ sorting: { sortModel: [{ field: "systime", sort: "desc" }] } }}
                            checkboxSelection={false}
                            disableRowSelectionOnClick
                            showToolbar />
                    </Box>
                </div>
            </div >
        );
    }
}
export default onboarding